import { render, staticRenderFns } from "./NovaAcao.vue?vue&type=template&id=0a5f746b&scoped=true"
import script from "./NovaAcao.vue?vue&type=script&lang=js"
export * from "./NovaAcao.vue?vue&type=script&lang=js"
import style0 from "./NovaAcao.vue?vue&type=style&index=0&id=0a5f746b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5f746b",
  null
  
)

export default component.exports